import { DeleteActionIcon } from '@common';

type DeletePropsType = {
  onClick: () => void;
};

export const Delete: React.FC<DeletePropsType> = ({ onClick }) => {
  return <DeleteActionIcon onClick={onClick} />;
};
